// extracted by mini-css-extract-plugin
module.exports = {"base":"Message_base__2CBHa","title":"Message_title__3IwKm"};